/**
 * This file is created to contain all react dependencies.
 * react, react-dom, prop-type
 */
/* eslint-disable */
export const React = require('react');
export const ReactDOM = require('react-dom');
export const PropTypes = require('prop-types');
/* eslint-enable */
